import { InvitationState } from './invitation-reducer';
import { InvitationActions, INVITATION_ACTION_TYPE } from './invitation-type';

export const invitationCreators = {
  setInvitationState: <KeyName extends keyof InvitationState>(key: KeyName, value: InvitationState[KeyName])
    : InvitationActions => ({
      type: INVITATION_ACTION_TYPE.SET_INVITATION_STATE,
      payload: { key, value }
    }),
};
